<template>
  <div class="Topbar">
    <div class="left"></div>
    <div class="right">
      <div class="user">
        <img :src="userState.data.avatar" alt="" />
        {{ userState.data.name }}
        <div class="logout" @click="doLogout"><x-icon size="1.25x" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import store from "@/store";
import { XIcon } from "@zhuowenli/vue-feather-icons";

export default {
  name: "Topbar",
  components: { XIcon },
  setup() {
    const userState = reactive(store.state.user);

    function doLogout() {
      store.dispatch("user/logoutUser");
    }

    return { doLogout, userState };
  }
};
</script>

<style lang="scss" scoped>
.Topbar {
  line-height: 43px;
  padding: 12px 24px;
  background-color: #fff;
  display: flex;
  position: fixed;
  right: 0px;
  top: 0px;
  left: 280px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #fff;
  > .left {
    flex-grow: 1;
  }
  .user {
    font-size: 14px;
    color: #444;
    background-color: #f1f1f1;
    box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.2);
    line-height: 42px;
    img {
      margin-right: 10px;
      height: 43px;
      width: 43px;
      display: inline-block;
      vertical-align: top;
    }
    .logout {
      margin-left: 16px;
      text-align: center;
      vertical-align: middle;
      display: inline-block;
      border-left: 1px solid rgba(#000, 0.075);
      width: 44px;
      cursor: pointer;
      &:hover {
        color: #f55934;
      }
      svg {
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 2px;
      }
    }
  }
}
</style>
